import { useState, useEffect } from "react";

// 他IdP（BizSOLなど）の提供サービスへ遷移するときに、
// 「他IdPでは未ログイン＆Mikatano IDではログイン済み」の場合に
// 他IdPのサービス画面に遷移すると、エラーになる。
// その際、エラーにならないよう他IdPの未ログインでも表示可能なページへの遷移を行うよう制御するために
// どのIdPからのログインかを保持する
// 具体例：
//   1. Mikatano IDでログインする（Bizsolログインだけでなく、Mikatano IDでのログインも許可している金融機関の場合）
//   2. Mikatano 資金管理からBizSOLへ相互遷移する
//   3. Mikatano IDでログインしているので、BizSOLの相互遷移用トップ画面へはアクセスせず、BizSOLの通常ログイン画面へ遷移する

// どのIdPからのログインかを保持する
const lastLoginSourceKey = "LastLoginSource";
export enum LoginSource {
  none, // 未ログイン (ログインしているかどうかの判定には使わない)
  mikatano, // Mikatanoログイン
  bizsol, // Bizsolログイン
  connectboard, // ConnectBoardログイン
  aegis, // Aegis (Keycloak) ログイン
}

// useIsLogedInFromBizsol is used to check if the user is logged in from Bizsol.
export const useIsLogedInFromBizsol = () => {
  const source = useLoginSource();
  return source === LoginSource.bizsol;
};

// useNoLoginSource is used to check if the LastLoginSource is none.
export const useNoLoginSource = () => {
  const source = useLoginSource();
  return source === LoginSource.none;
};

export const useIsLoginFromAegis = () => {
  const source = useLoginSource();
  return source === LoginSource.aegis;
};

// This function is used to set the login source.
export const setLoginSource = (source: LoginSource) => {
  // Add login source to the cookie with secure flag.
  document.cookie = `${lastLoginSourceKey}=${source}; path=/; secure`;
};

// This function is used to get the login source.
// Login source value is stored in the cookie.
export const useLoginSource = () => {
  const [source, setSource] = useState<LoginSource>(LoginSource.none);

  useEffect(() => {
    const cookie = document.cookie;
    const source = cookie
      .split(";")
      .map((c) => c.trim())
      .find((c) => c.startsWith(lastLoginSourceKey));
    if (source) {
      setSource(Number(source.split("=")[1]));
    }
  }, []);

  return source;
};
